import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, JCP_PROGRAM_ID, PF_PROGRAM_ID, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.todayDate("/"),
    receipt_end_date: commonUtility.todayDate("/"),
    member_id: "",
    programme_id : PF_PROGRAM_ID
};



const OtherItemsListPF = () => {
    const [form] = Form.useForm();
  
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [memberList, setMemberList] = useState([]);
    const [otherItemsList, setOtherItemsList] = useState([]);
    const [otherItemsMasterList, setOtherItemsMasterList] = useState([]);
    const [otherItemsDetailList, setOtherItemsDetailList] = useState([]);

   

    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            receipt_start_date: dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            receipt_end_date: dateString
        });

    };


    const onSelectMember = (value) => {
        const data = { formdata: { member_id: value } };

        form.setFieldsValue({
            member_id:value
        });
    };

    const onOtherItemsSearched = async (values) => {

        setOtherItemsList([])
        setOtherItemsMasterList([])
        setOtherItemsDetailList([])

        

        const formdValues = {
            member_id: values.member_id == undefined ? '' :  values.member_id,
            receipt_end_date : values.receipt_end_date,
            receipt_start_date : values.receipt_start_date,
            programme_id : PF_PROGRAM_ID
       
        }
      

        const data = { formdata: formdValues };
        
        ProgrammeService.otherItemsReceiptList(data).then((res) => {

            if(commonUtility.sanitizeObject(res)) {
                const other_item_data = res.response_data;
                setOtherItemsList(res.data.response_data)
                
                if(other_item_data && commonUtility.sanitizeObject(other_item_data.masterData)) {
                    setOtherItemsMasterList(other_item_data.masterData)
                }
            
                if(other_item_data && commonUtility.sanitizeObject(other_item_data.detailsData)){
                    setOtherItemsMasterList(other_item_data.detailsData)
                }
            }
            
            setIsDataUpdated(!isDataUpdated)
        });
    };




    

    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);


    useEffect(()=> {
        const formdValues = {
            member_id: form.getFieldValue('member_id') == undefined ? '' :  form.getFieldValue('member_id'),
            receipt_start_date: commonUtility.todayDate("/"),
            receipt_end_date: commonUtility.todayDate("/"),
            programme_id : PF_PROGRAM_ID
        }
        onOtherItemsSearched(formdValues)
    },[])

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Other Items List - PF"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "transparent" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                     onFinish={onOtherItemsSearched}
                                    autoComplete="off"
                                   initialValues={defaultFormValues}
                                >

                                    <Row gutter={20} >

                                        <Col xs={24} xl={5} >

                                            <Form.Item name="from_date_picker" label="From Date">
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.todayDate(), DATE_FORMAT_DMY_SLASH)}
                                                    
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_start_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={5} >

                                            <Form.Item name="to_date_picker" label="End Date" >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    defaultValue={moment(commonUtility.todayDate(), DATE_FORMAT_DMY_SLASH)}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_end_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={6} xl={6} >
                                            <Form.Item
                                                name="member_id"
                                                label="Search (Name | Mobile no | Father Name)"

                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.includes(input)
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    onSelect={(value, event) =>
                                                        onSelectMember(value, event)
                                                    }
                                                    allowClear={true}
                                                >
                                                    {memberList.length > 0
                                                        ? memberList.map((member_list) => (
                                                            <Option
                                                                key={member_list.member_id}
                                                                value={member_list.member_id}
                                                            >
                                                                {`${member_list.member_fname} ${member_list.member_lname
                                                                    } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                        ? member_list.father_name
                                                                        : ""
                                                                    }`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                             
                                            </Form.Item>
                                        </Col>





                                        <Col xs={24} xl={3}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"

                                                    className="custom-button-green"
                                                >
                                                    Search <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>





                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}

                        

                        <div className='tableView'>
                        <div className="form-content">
                        <OtherItemsListView otherItemListValue={otherItemsList} otherItemsMasterListValue={otherItemsMasterList} otherItemsDetailListValue={otherItemsDetailList} isDataUpdatedValue={isDataUpdated} module={`PF`} />
                        </div>
                    </div>




                    </div>

                </div>
            </div>

        </div>


    )
}

export default OtherItemsListPF